import React, { useEffect, useState } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';
import Signup from './pages/AgentPage/Signup.js';
import Login from './pages/AgentPage/Login.js';
import "bootstrap/dist/css/bootstrap.min.css";
import AddProperty from './pages/AgentPage/AddProperty';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { AddPropertyResidentialRent1 } from './pages/AgentPage/AddPropertyResidentialRent1.js';
import "leaflet/dist/leaflet.css";
import AddPropertyResidentialResell from './pages/AgentPage/AddPropertyResidentialResell';
import AddPropertyCommercialRent from './pages/AgentPage/AddPropertyCommercialRent';
import { AddPropertyCommercialResale } from './pages/AgentPage/AddPropertyCommercialResale';
import Dashboard from './pages/AgentPage/Dashboard';
import 'bootstrap/dist/css/bootstrap.min.css';
import ProtectedRoute from './pages/ProtectedRoute.js';
import Listings from './pages/AgentPage/Listings.js';
import Homepage from './pages/userfolder/Homepage.js';
import { PropertyDetails } from './pages/userfolder/PropertyDetails.js';
import SearchPage from './pages/userfolder/SearchPage.js';
import { Footer } from './pages/Footer.js';
import StickySocialIcons from './pages/userfolder/SocialMediaIcons.js';
import Aboutpage from './pages/userfolder/Aboutpage.js';
import Contact from './pages/userfolder/ContactPage.js';
import { NewProject } from './pages/AgentPage/NewProject.js';
import ScrollToTop from "./ScrollToTop";
import NewProjectsByStatusWrapper from './pages/userfolder/NewProjectsByStatusWrapper.js';
import { Newlistingslanding } from './pages/userfolder/Newlistingslanding.js';
import { ReadyToMove } from './pages/userfolder/Propertpage/ReadyToMove.js';
import { AlmostReady } from './pages/userfolder/Propertpage/AlmostReady.js';
import {PremiumHomes} from './pages/userfolder/Propertpage/PremiumHomes.js';
import { NewProjectsByStatus } from './pages/AgentPage/NewProjectsByStatus.js';
import { NewsearchProject } from './pages/userfolder/NewsearchProject.js';
import { Onlyplotsfecting } from './pages/userfolder/Onlyplotsfecting.js';


function App() {

  const [agentId, setAgentId] = useState(null);
  const [agentName, setAgentName] = useState(null);

  useEffect(() => {
    const storedAgentId = localStorage.getItem("agent_id");
    const storedAgentName = localStorage.getItem("agent_name");

    if (storedAgentId) setAgentId(storedAgentId);
    if (storedAgentName) setAgentName(storedAgentName);
  }, []);

  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <StickySocialIcons />
        <Routes>
          <Route path='/dashboard' element={<ProtectedRoute> <Dashboard /></ProtectedRoute>} />
          <Route path='/residential-rent' element={<AddPropertyResidentialRent1 agent_id={agentId} agent_name={agentName} />} />
          <Route path='/residential-resell' element={<AddPropertyResidentialResell agent_id={agentId} agent_name={agentName} />} />
          <Route path='/Commercial-rent' element={<AddPropertyCommercialRent agent_id={agentId} agent_name={agentName} />} />
          <Route path='/Commercial-resale' element={<AddPropertyCommercialResale agent_id={agentId} agent_name={agentName} />} />
          <Route path='/pg-co-living' element={<AddProperty agent_id={agentId} agent_name={agentName} />} />
          <Route path='/Newproject' element={<NewProject agent_id={agentId} agent_name={agentName} />} />
          <Route path='/listings' element={<Listings agent_id={agentId} />} />
          <Route path='/signup' element={<Signup />} />
          <Route path='/login' element={<Login />} />
          <Route path='/' element={<Homepage />} />
          <Route path="/property/:category/:id" element={<PropertyDetails />} />
          <Route path="/new-projects/:status" element={<NewProjectsByStatusWrapper />} />
          <Route path="/Plots/:status" element={<Onlyplotsfecting />} />
          <Route path="/new-project/:projectid" element={<Newlistingslanding />} />
          <Route path='/search' element={<SearchPage />} />
          <Route path='/new-search-projects' element={<NewProjectsByStatus />} />
          <Route path='/new-projects-search' element={<NewsearchProject />} />
          <Route path='/about' element={<Aboutpage />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/ready-to-occupy-homes-in-chennai' element={<ReadyToMove />} />
          <Route path='/completed-projects-in-chennai' element={<AlmostReady />} />
          <Route path='/luxury-homes-in-chennai' element={<PremiumHomes />} />
          
        </Routes>
        <Footer />
      </Router>

    </div>
  );
}

export default App;
